/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NoticeDto } from '../../models/notice-dto';
import { NoticeUpdateDto } from '../../models/notice-update-dto';

export interface NoticeControllerUpdate$Params {
  id: string;
      body: NoticeUpdateDto
}

export function noticeControllerUpdate(http: HttpClient, rootUrl: string, params: NoticeControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<NoticeDto>> {
  const rb = new RequestBuilder(rootUrl, noticeControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NoticeDto>;
    })
  );
}

noticeControllerUpdate.PATH = '/api/notices/{id}';
